export enum TABLE_MODE {
    SERVER = 'server',
    CLIENT = 'client'
}
